// removed by extract-text-webpack-plugin
module.exports = {"custom-switch":"SwitchList--custom-switch---9bE6sts","customSwitch":"SwitchList--custom-switch---9bE6sts"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/SwitchList/SwitchList.css
// module id = 313
// module chunks = 2